import React from 'react'
// import LoaderButton from '../../components/LoaderButton'
// import FormViewer from '../../components/FormViewer'
import { translate } from "../../utils/useful";
// import Responsive from '../../components/Responsive';
// import TableViewer from '../../components/TableViewer';
// import SwitchInput from '../../components/inputs/SwitchInput';
// import StageActionButton from '../../components/partials/StageActionButton';
// import AddPermissionModal from '../../modals/AddPermissionModal';
// import SearchUsersModal from '../../modals/SearchUsersModal';
// import SearchGroupsModal from '../../modals/SearchGroupsModal';
// import SidebarView from '../../components/SidebarView';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
// import ActionButton from '../../components/partials/ActionButton';
// import CAHeader from '../../components/header/CAHeader';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
// import TextInput from '../../components/inputs/TextInput';
import { nanoid } from 'nanoid';
// import SelectInput from '../../components/inputs/SelectInput';
// import Collapsible from 'react-collapsible';
// import CheckboxInput from '../../components/inputs/CheckboxInput';
// import FilterEditorInput from '../../components/inputs/FilterEditorInput';
// import RadiusSelectInput from '../../components/inputs/RadiusSelectInput';
// import HelpButton from '../../components/HelpButton';
import PermissionsView from '../../components/PermissionsView';

class CAAccess extends React.Component {
    state = {

        actions: {
            edit: { key: "edit", label: "{{lang}}ca.Edit", color: '#677dc4', bgColor: '#677dc4', function: "openEditUser" },
            remove: { key: "remove", label: "{{lang}}ca.Remove", color: '#ee5050', bgColor: '#ee5050', function: "openRemoveModal" },
        },

        // headerConfig: {
        //     showToolbar: false, showSettings: true, showFrames: 'createApplet', type: 'createApplet', isPortal: false, title: 'Manage Admins Access',
        // },

        customAccess: {

        },

        frames: [],

        tabsView: {},

        // headers: [
        //     { type: 'GlobalUserInput', key: 'user', information: { label: "{{lang}}User", placeholder: '{{lang}}User', required: true } },
        //     { type: 'TextInput', key: 'permissions', information: { label: "{{lang}}Permissions", placeholder: '{{lang}}Permissions', required: true } },

        // ],
        admins: [],
        users: [],
        public: true,

        permissionsObject: {},
        // permissionsObject: {
        //     postMessage: { key: 'postMessage', label: '{{lang}}ca.Post Message' },
        //     editMessageOfOthers: { key: 'editMessageOfOthers', label: '{{lang}}ca.Edit Message Of Others' },
        //     deleteMessageOfOthers: { key: 'deleteMessageOfOthers', label: '{{lang}}ca.Delete Message Of Others' },
        //     invitUsersViaLink: { key: 'invitUsersViaLink', label: '{{lang}}ca.Invite Users Via Link' },
        //     manageVideoChats: { key: 'manageVideoChats', label: '{{lang}}ca.Manage Video Chats' },
        //     editApplet: { key: 'editApplet', label: '{{lang}}ca.Edit Applet', },
        //     editPermissions: { key: 'editPermissions', label: '{{lang}}ca.Edit Permissions' },
        // },

    }

    componentDidMount() {
        let me = this.props.user?.info
        let admins
        let users
        let publicStatus
        let owner

        if (this.props.initData?.permissions) {
            // console.log('this.props.initData99', this.props.initData)
            admins = this.props.initData?.permissions?.admins
            users = this.props.initData?.permissions?.users
            publicStatus = this.props.initData?.permissions?.public
            owner = this.props.initData?.permissions?.owner
        } else {
            // admins = [{ name: 'Owner', id: 'owner', mainAccess: true, hubs: [{ _id: me?._id, image: me?.image, fullname: me?.fullname, username: me?.username, type: 'user', owner: true }], permissions: '*' }]
            admins = [
                { name: 'Full access', id: 'owner', locked: true, type: 'role', mainAccess: true, hubs: [{ _id: me?._id, image: me?.image, fullname: me?.fullname, username: me?.username, type: 'user', owner: true }], permissions: [] },
                { name: 'General', id: 'general', type: 'role', hubs: [], permissions: [] }
            ]

            users = []
            publicStatus = true
            owner = me?._id
        }



        let frames = []

        // console.log('caathis.props.initData?.features', this.props.initData?.features)
        // console.log('firstfeature', this.props)
        // if (this.props.initData?.features) {

        // let feature = this.props.initData?.features[0]
        // { console.log('mdjsbhchcgshjdc', feature) }
        // TO DO: Consider edit of permissions
        // console.log('firstfeaturepermissions', JSON.parse(JSON.stringify(admins[0].permissions)))
        // console.log(this.props.initData?.frames)
        // console.log(feature)
        // console.log(admins)

        if (admins && Array.isArray(this.props.initData?.frames)) {
            frames = this.props.initData?.frames

            frames.forEach(frame => {
                if (frame.headers && !frame.fields) {
                    frame.fields = frame.headers

                }

                if (frame.title && !frame.name) {
                    frame.name = frame.title

                }

                if (frame.key && !frame.id) {
                    frame.id = frame.key
                }

                if (!this.props.initData?.permissions) {
                    admins.forEach(admin => {
                        let access = '*'
                        if (!admin.locked && frame.pageType == 'collection') {
                            access = { view: '*', create: '*', edit: '*', remove: '*' }
                        }
                        admin.permissions.push({ id: frame.id, type: 'frame', pageType: frame.pageType, access: access })
                    });
                }
            });


            if (!admins[0]) {
                return
            }
            admins[0].permissions.push({ id: "applet", type: 'applet', access: '*' })

            this.setState({ admins, frames, users, owner, public: publicStatus }, () => {
            })

        }
        // switch (feature) {
        //     case "Database": {

        //         let fields = []
        //         let form = this.props.initData?.collectionInfo?.form

        //         if (form && form[0]) {
        //             form[0]?.pageContent[0]?.sectionContent?.map((prop) => {
        //                 prop.rowContent.map((element) => {
        //                     // console.log('element')
        //                     if (!element.key.includes('values.')) {
        //                         element.key = 'values.' + element.key
        //                     }
        //                     fields.push(element)
        //                 })
        //             })
        //         }

        //         frames.push({ name: this.props.initData?.collectionInfo?.collectionName, fields, id: 'collection', type: 'collection', })
        //         admins[0].permissions.push({ id: "collection", type: 'frame', access: '*', })
        //         admins[1].permissions.push({ id: "collection", type: 'frame', access: '*' })
        //         break

        //     }
        //     case "Messenger": {

        //         frames.push({ name: this.props.initData?.collectionInfo?.collectionName, id: 'collection', type: 'messenger', })
        //         admins[0].permissions.push({ id: "frame", type: 'frame', access: '*', })
        //         admins[1].permissions.push({ id: "frame", type: 'frame', access: '*' })
        //         break
        //     }
        //     case "Finance": {



        //         break

        //     }
        //     case "Commerce": {


        //         break

        //     }

        //     case "Tasking": {


        //         break

        //     }

        //     case "Drive": {


        //         break

        //     }
        //     case "Notebook": {


        //         break

        //     }
        //     case "Inquiry": {


        //         break


        //     }
        //     default:
        //         break;
        // }


        // }
        // else if (this.props.applet?.features) {
        //     let feature = this.props.applet?.features[0]
        //     // { console.log('mdjsbhchcgshjdc', feature) }
        //     // TO DO: Consider edit of permissions
        //     // console.log('firstfeaturepermissions', JSON.parse(JSON.stringify(admins[0].permissions)))
        //     switch (feature) {
        //         case "Database": {
        //             frames.push({
        //                 name: this.props.initData?.collectionInfo?.collectionName,
        //                 id: 'collection',
        //                 type: 'collection',
        //             })
        //             admins[0].permissions.push({ id: "collection", access: '*' })
        //             break;
        //         }
        //         case "Messenger": {
        //             admins[0].permissions.push({ id: "applet", applet: '*' })
        //             break
        //         }
        //         case "Finance": {
        //             admins[0].permissions.push({ id: "applet" })
        //             break
        //         }
        //         case "Commerce": {
        //             admins[0].permissions.push({ id: "applet", applet: '*' })
        //             break
        //         }
        //         case "Tasking": {
        //             admins[0].permissions.push({ id: "collection", access: '*' })
        //             break
        //         }
        //         case "Drive": {
        //             admins[0].permissions.push({ id: "applet", applet: '*' })
        //             break
        //         }
        //         case "Notebook": {
        //             admins[0].permissions.push({ id: "applet", applet: '*' })
        //             break
        //         }
        //         case "Inquiry": {
        //             admins[0].permissions.push({ id: "collection", access: '*', applet: '*' })
        //             break
        //         }
        //         default:
        //             break;
        //     }
        // }
        // console.log('admins[0].permissions', admins[0].permissions)


        if (this.props.setHeader) {
            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                isPortal: true, doNotshowNotification: true,
                showSettings: false,
                create: true,
                'title': this.props.description ?? 'Create Applet | Admins Access',
                topHeaderComponent: this.topHeaderComponent,
                backAction: () => this.props.lastStage()

            })
        }

    }
    onNextStage = () => {
        if (this.props.handleNextStage) {
            this.props.handleNextStage({ admins: this.state.admins, users: this.state.users, })
        }
        else {
            this.nextStage()
        }
    }


    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    isLoading={this.state.isLoading}
                    // onClick={() => this.props.nextStage ? this.props.nextStage({ admins: this.state.admins, users: this.state.users, }) : this.nextStage()}
                    onClick={this.onNextStage}
                    title={this.props.title ?? translate("ca.Continue")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />

            </div>

        )
    }



    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }


    componentWillUnmount() {
    }


    nextStage = () => {

        // TODO: Permissions

        let data = {
            admins: this.state.admins,
            // users: this.state.users,
            // publicPermissions: this.state.public,
        }

        let frames = this.state.frames
        // console.log(data)


        // let data = this.form.getForm()
        if (data) {
            // console.log('dseklnfjdnjk', this.props)
            this.props.setData({ permissions: data, frames }, () => {
                // this.props.nextStage()
                // console.log('permissionspermissions', this.props.initData)

                if (this.props.continue) {
                    this.props.continue(this.props.stageName)
                } else {

                    if (this.props.changeStage) {
                        if (Array.isArray(this.props.initData.features) && this.props.initData.features[0] == 'Inquiry') {
                            this.props.changeStage('info')
                        }
                        else {
                            this.props.changeStage('formType')
                        }
                    }
                }


            })
        }
    }


    changeValue = (key, value) => {
        this.setState({ [key]: value })
    }

    // openAddAdmin = (index, type) => {
    //     // let groupsInitData = []
    //     // let hubsInitData = []
    //     let groups
    //     let hubs

    //     if (index != null) {
    //         groups = this.state[type][index]?.groups
    //         hubs = this.state[type][index]?.hubs
    //         // console.log(groups)
    //         // console.log(hubs)
    //         // if (groups) {
    //         //     groups.forEach(element => {
    //         //         groupsInitData.push(element._id)
    //         //     });
    //         // }
    //         // if (hubs) {
    //         //     hubs.forEach(element => {
    //         //         hubsInitData.push(element._id)
    //         //     });
    //         // }
    //     }


    //     this.setState({ currentType: type, currentItemIndex: index, groupsInitData: groups, hubsInitData: hubs }, () => {
    //         this.addPermissionModal.modal.showModal()
    //     })
    // }


    // permissionTypeSelected = (type) => {
    //     if (type == 'users') {
    //         this.searchUsersModal.showModal()
    //     } else {
    //         this.searchGroupsModal.showModal()
    //     }
    // }


    // addRole = () => {
    //     let currentItemIndex
    //     let currentType = 'admins'
    //     let list = this.state[currentType]
    //     // let listType = 'admins'

    //     let admins = this.state.admins
    //     let roleName = 'Role ' + admins.length ?? 1

    //     // list.push({ name: roleName, id: nanoid(), permissions: '*' })
    //     list.push({ name: roleName, id: nanoid(), permissions: [{ id: "collection", access: '*', applet: '*' }] })
    //     currentItemIndex = list.length - 1

    //     let item = list[currentItemIndex]



    //     this.openPermissions(item, currentItemIndex, currentType)
    // }


    // onNewUsersSelected = (users, type, cb) => {

    //     // console.log(users)
    //     // console.log(type)

    //     let list = this.state[this.state.currentType]
    //     let currentItemIndex = this.state.currentItemIndex

    //     users.forEach(element => {
    //         element.type = type
    //     });

    //     let listType = type + 's'




    //     if (currentItemIndex != null) {

    //         if (!list[currentItemIndex][listType]) {
    //             list[currentItemIndex][listType] = []
    //         }

    //         // list[currentItemIndex][listType] = [...list[currentItemIndex][listType], ...users]
    //         list[currentItemIndex][listType] = [...users]

    //     } else {

    //         list.push({ [listType]: users, permissions: '*' })
    //         currentItemIndex = list.length - 1
    //     }

    //     let item = list[currentItemIndex]

    //     // console.log(users)
    //     // console.log(list)
    //     // console.log([...list.list,...users])
    //     // list.list = [...list.list,...users]

    //     // console.log(list)
    //     // console.log(currentItemIndex)

    //     this.setState({ [this.state.currentType]: list }, () => {
    //         // this.openPermissions(item, currentItemIndex, this.state.currentType)
    //     })
    //     cb()
    //     // let newInfo = 
    // }


    // removeUser = (id, type) => {

    // }

    removePermission = (item, index, type) => {
        if (!item.mainAccess) {
            let list = this.state[type]
            list.splice(index, 1)
            this.setState({ [type]: list })
        } else {
            this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.canNotChange', description: translate("The list which includes the owner can not be removed") })

        }
    }

    // openPermissions = (item, index, type) => {

    //     // console.log("openPermissions")
    //     // console.log(index)

    //     if (index != null) {
    //         this.sidebarView.open()

    //         let listHasOwner = false
    //         // console.log("openPermissions")
    //         // console.log(item.list)
    //         if (item?.hubs && Array.isArray(item.hubs)) {
    //             item.hubs.forEach(element => {
    //                 if (element.owner == true) {
    //                     listHasOwner = true
    //                 }
    //             });

    //             // console.log(item)

    //         }

    //         this.setState({ currentType: type, isMainAccess: item?.mainAccess, currentItem: item, listHasOwner, currentItemIndex: index })

    //     } else {

    //     }
    // }


    // showPermissionsText = (permissions) => {
    //     let text = ''

    //     if (permissions == '*') {
    //         text = translate("Full Access")
    //     } else {
    //         text = Object.values(permissions).length + translate(' Permissions')
    //         if (Object.values(permissions).length == 0) {
    //             text = translate("No Permissions, Will be removed")
    //         }
    //     }

    //     return text
    // }


    // infoView(user, index, type) {
    //     return (
    //         <div className='flexc py-1 w-100' style={{ borderBottom: '0px solid #f2f2f2' }}>

    //             <ActionButton>
    //                 <div className=" mt-0  py-2 px-3 d-flex flex-column w-100 " style={{ minWidth: 180, boxShadow: '0px 0px 50px #10101050', backgroundColor: '#fff', borderRadius: 6 }}>
    //                     {/* <button onClick={() => this.openPermissions(user, index, 'admins')} className="w-100 p-0 text-start flexcb mt-1" >
    //                         <p className="text-small  ">{translate('ca.Edit')}</p>
    //                         <img src='/assets/icons/useful/text.svg' height={15} />

    //                     </button> */}

    //                     <button onClick={() => { this.removePermission(user, index, 'admins') }} className="w-100 p-0 mt-2 mb-2 text-start flexc" >
    //                         <img src='/assets/icons/useful/flow-1.png' height={14} />
    //                         <p className="text-smaller mx-1">{translate('Change Role')}</p>
    //                     </button>


    //                     {!user.mainAccess && (
    //                         <button onClick={() => { this.removeUserFromPermission(user, type, index) }} className="w-100 p-0 mt-1 text-start flexc mb-2" >
    //                             <img src='/assets/icons/useful/trash-o.svg' height={14} />
    //                             <p className="text-smaller mx-1">{translate('Remove from role')}</p>

    //                         </button>
    //                     )}


    //                 </div>
    //             </ActionButton>

    //             <div className='mx-2 flexcc'>
    //                 {user.type == 'group' ? (
    //                     <img className='task-check-img' src={'/images/icons/comunities.png'} height={24} width={24} style={{ borderRadius: 20 }} />
    //                 ) : (
    //                     <img className='task-check-img' src={imageAddress(user?.image, 'profile')} height={24} width={24} style={{ borderRadius: 20 }} />
    //                 )}
    //             </div>

    //             <div className='flexc flex-1'>

    //                 <div>
    //                     <p className='task-title  text-small text-semibold  cursor-pointer'>{user.fullname ?? user.name}</p>
    //                     <p className='task-title  text-smallest  cursor-pointer' style={{ color: '#666' }}>{user.username ? ("@" + user.username) : translate("Group")}</p>
    //                 </div>
    //                 {/* <div className='flexc'>
    //                                                                                     <p className='task-applet-name text-smaller color-gray-2  cursor-pointer mt-1 '>Username</p>
    //                                                                                 </div> */}

    //                 {user.owner && (
    //                     <div className='mld-2 flexcc px-2 py-1' style={{ backgroundColor: '#eee', borderRadius: 20 }}>
    //                         <p className='text-smaller color-gray-1'>{translate('ca.Owner')}</p>
    //                     </div>
    //                 )}

    //             </div>
    //         </div>
    //     )
    // }


    // permissionInfoView(user, type, index) {
    //     return (
    //         <div className='flexcb mb-1 pb-1' style={{ borderBottom: '1px solid #f6f6f6' }}>


    //             <div className='flexc'>
    //                 <div className='mld-2 mrd-3 flexcc'>

    //                     {user.type == 'group' ? (
    //                         <img className='task-check-img' src={'/images/icons/comunities.png'} height={26} width={26} style={{ borderRadius: 20 }} />

    //                     ) : (
    //                         <img className='task-check-img' src={imageAddress(user?.image, 'profile')} height={26} width={26} style={{ borderRadius: 20 }} />
    //                     )}
    //                 </div>

    //                 <div className='d-flex flex-column  flex-1'>
    //                     <div className='flexc'>
    //                         <p className='task-title  text-small  '>{user.fullname ?? user.name}</p>
    //                         {user.owner && (
    //                             <div className='mld-2 flexcc px-2 py-1' style={{ backgroundColor: '#eee', borderRadius: 20 }}>
    //                                 <p className='text-smaller color-gray-1'>{translate('ca.Owner')}</p>
    //                             </div>
    //                         )}
    //                     </div>
    //                     {user.username && (
    //                         <p className='task-title  text-smaller  '>{user.username}</p>

    //                     )}

    //                     {user.type == 'group' && (
    //                         <p className='task-title  text-smaller color-gray-2 '>{translate('ca.group')}</p>

    //                     )}
    //                 </div>
    //             </div>

    //             {!user.owner && (
    //                 <button onClick={() => this.removeUserFromPermission(user, type, index)} className='mx-2  flexcc' style={{ backgroundColor: '#eee', borderRadius: 20, width: 18, height: 18 }}>
    //                     <img className='opacity-5' src={'/assets/icons/close.svg'} height="14px" />
    //                 </button>
    //             )}

    //         </div>
    //     )
    // }

    // editRoleName = (key, value, extra) => {

    //     let list = this.state[this.state.currentType]
    //     // let admin = list[extra.index]
    //     list[this.state.currentItemIndex].name = value

    //     console.log(value)
    //     this.setState({ [this.state.currentType]: list })

    // }



    // removeUserFromPermission = (user, type, index) => {
    //     console.log("removeUserFromPermission")
    //     let currentType = this.state.currentType ?? 'admins'
    //     console.log(this.state.currentType)

    //     // return
    //     let list = this.state[this.state.currentType]
    //     console.log(type)
    //     // console.log(list[this.state.currentItemIndex])
    //     list[this.state.currentItemIndex][type].splice(index, 1)
    //     this.setState({ [this.state.currentType]: list })
    // }



    // changePermission = (key, value, extra) => {

    //     if (this.state.listHasOwner && this.state.isMainAccess) {
    //         this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.canNotChange', description: "The list which includes the owner should have full access" })
    //         return
    //     }
    //     let list = this.state[this.state.currentType]
    //     let admin = list[extra.index]

    //     let permissions = admin.permissions
    //     if (permissions == '*') {
    //         permissions = {}
    //         for (const [pkey, pvalue] of Object.entries(this.state.permissionsObject)) {
    //             permissions[pkey] = true
    //         }

    //     }
    //     if (permissions == null) {
    //         permissions = {}
    //     }
    //     permissions[key] = value
    //     if (!permissions[key]) {
    //         delete permissions[key]
    //     }

    //     if (Object.keys(this.state.permissionsObject).length == Object.keys(permissions).length) {
    //         permissions = '*'
    //     }

    //     list[extra.index].permissions = permissions

    //     this.setState({ [this.state.currentType]: list })
    // }



    // changeAccess = (frame, permission, value, headers) => {


    //     // console.log("!!!!!,", permission)
    //     let list = this.state.admins
    //     // let list = admins
    //     let admin = list[this.state.currentItemIndex]
    //     let permissions = admin.permissions
    //     let framePermission
    //     let framePermissionIndex



    //     permissions.forEach((fpermission, index) => {
    //         if (fpermission.id == frame.id || fpermission._id == frame._id) {
    //             framePermission = fpermission
    //             framePermissionIndex = index
    //         }
    //     });

    //     // console.log(permission)
    //     // console.log(framePermission)


    //     // let key = (frame._id ?? frame.id) + '.' + permission.key

    //     let keys = ('access.' + permission.key).split('.')

    //     let parentKey = keys.splice(keys.length - 1, 1).join('.')


    //     framePermission.access = this.createPermissionHierarchy(framePermission, permission, keys, headers, value)

    //     console.log(framePermission)

    //     // return
    //     // let permissionKey = permission.key
    //     // let headers = permission.headers ?? {}

    //     // if (permission.headers == 'collection') {
    //     //     headers = {
    //     //         view: { key: 'view', title: '{{lang}}view', main: true },
    //     //         create: { key: 'create', title: '{{lang}}create', dependancy: 'view', main: true },
    //     //         edit: { key: 'edit', title: '{{lang}}edit', dependancy: 'view', main: true },
    //     //         delete: { key: 'remove', title: '{{lang}}Remove', dependancy: 'view', main: true },
    //     //         manage: { key: 'manage', title: '{{lang}}Manage', main: true },

    //     //     }
    //     // }


    //     // console.log(key)


    //     // let permissionStatus = getPermissionObject(framePermission, 'access.' + key)
    //     // console.log(permissionStatus)


    //     // if (value == null) {

    //     //     console.log("TP!!!2")
    //     //     console.log(value)


    //     //     // if (permissionStatus.parentLevel) {
    //     //     // setObject(framePermission, parentKey, null)

    //     //     Object.values(headers).forEach(pheader => {

    //     //         if (pheader.key == permission.key) {
    //     //             console.log(pheader.key)
    //     //             setObject(framePermission, ('access.' + pheader.key), null)
    //     //         }
    //     //         if (pheader.dependancy == permission.key) {
    //     //             if (getPermissionObject(framePermission, ('access.' + pheader.key)).value == null) {
    //     //                 setObject(framePermission, ('access.' + pheader.key), null)
    //     //             }
    //     //         }
    //     //     });
    //     //     // } 
    //     //     // else {
    //     //     //     // setObject(permissions, key, null)
    //     //     //     Object.values(headers).forEach(pheader => {
    //     //     //         // console.log(pheader)
    //     //     //         // console.log(permission)
    //     //     //         if (pheader.key == permission.key || pheader.dependancy == permission.key) {
    //     //     //             setObject(framePermission, 'access.' + pheader.key, null)
    //     //     //         }
    //     //     //     });
    //     //     // }

    //     // } else {

    //     //     console.log("TP!!!1")
    //     //     console.log(value)

    //     //     // setObject(permissions, key, '*')
    //     //     Object.values(headers).forEach(pheader => {

    //     //         // if (pheader.key == permission.key || pheader.dependancy == permission.key) {
    //     //         if (pheader.key == permission.key) {
    //     //             // console.log("!!!")
    //     //             setObject(framePermission, 'access.' + pheader.key, null)
    //     //         }
    //     //         if (permission.dependancy == pheader.key) {
    //     //             // if (getPermissionObject(framePermission, ('access.' + pheader.key)).value == null) {
    //     //             setObject(framePermission, 'access.' + pheader.key, null)
    //     //             // }
    //     //         }
    //     //     });
    //     // }



    //     let permissionValue = getPermissionObject(framePermission, parentKey).value


    //     if (permissionValue != '*' && permissionValue != null && typeof permissionValue == 'object') {


    //         let keys = typeof parentValue == 'object' ? Object.keys(permissionValue) : []
    //         let keysCount = 0
    //         keys.forEach(element => {
    //             if (!element.startsWith('*')) {
    //                 keysCount++
    //             }
    //         });

    //         if (keysCount == Object.keys(headers).length) {


    //             setObject(framePermission, parentKey, '*')

    //             // setObject(framePermission, 'access.' + '**fullAccess', '*')
    //         } else if (keysCount > 0) {
    //             setObject(framePermission, 'access.' + '**fullAccess', '-')
    //         } else {
    //             setObject(framePermission, 'access.' + '**fullAccess', null)
    //         }
    //     }


    //     list[this.state.currentItemIndex].permissions[framePermissionIndex] = framePermission

    //     // let permissionsObject = this.state.permissionsObject

    //     // console.log(framePermission)

    //     this.setState({ admins: list }, () => {
    //         // this.permissionsToObject()
    //     })



    // }


    // createPermissionHierarchy = (framePermission, permission, keys, headers, value) => {

    //     let parentKey = keys.splice(keys.length - 1, 1).join('.')

    //     let parentValue = getObject(framePermission, parentKey)

    //     let output = parentValue
    //     // let key = permission.key

    //     // let parentKeys = keys.split('.')

    //     // let headerParentKey = parentKey

    //     // parentKey = 'access.' + parentKey
    //     // console.log(parentKey)

    //     let myHeaders = getObject({ access: headers }, parentKey)


    //     // console.log(myHeaders)




    //     // console.log(parentValue)

    //     if (output == '*') {

    //         output = {}
    //         // setObject(output, parentKey, {})

    //     }

    //     Object.values(myHeaders).forEach(pheader => {

    //         if (pheader.key == permission.key) {
    //             // console.log(pheader.key)
    //             setObject(output, pheader.key, value)
    //         } else {
    //             // if (value == null) {

    //             // console.log(headers)
    //             // console.log(permission.key)
    //             if (value == null) {

    //                 if (permission.key == pheader.dependancy) {
    //                     // if (headers[permission.key].dependancy == pheader.key) {
    //                     setObject(output, pheader.key, value == null ? null : '*')
    //                 } else {
    //                     if (parentValue == '*') {
    //                         if (getPermissionObject(output, pheader.key).value == null) {
    //                             setObject(output, pheader.key, '*')
    //                         }
    //                     }
    //                 }
    //             } else {
    //                 console.log('myHeaders', myHeaders)
    //                 if (myHeaders[permission.key].dependancy == pheader.key) {
    //                     if (getPermissionObject(output, pheader.key).value == null) {
    //                         setObject(output, pheader.key, '*')
    //                     }
    //                 }
    //             }

    //             // }
    //         }
    //     })

    //     console.log(output)
    //     return output


    // }


    // permissionsToObject = () => {
    //     let admins = this.state.admins
    //     let permissionsObject = {}



    //     admins.forEach(admin => {
    //         admin.permissions.forEach(permission => {

    //             // console.log(permission)
    //             let id = permission?._id ?? permission?.id
    //             permissionsObject[id] = permission.access
    //         });
    //     });

    //     console.log(permissionsObject)
    //     this.setState({ permissionsObject })

    // }

    // fullAccessedClicked = (frame, permission) => {

    //     let list = this.state.admins
    //     let admin = list[this.state.currentItemIndex]
    //     let permissions = admin.permissions
    //     let framePermission
    //     let framePermissionIndex


    //     // console.log(permissions)

    //     permissions.forEach((fpermission, index) => {
    //         if (fpermission.id == frame.id || fpermission._id == frame._id) {
    //             framePermission = fpermission
    //             framePermissionIndex = index
    //         }
    //     })

    //     // framePermission.access = '*'

    //     let value = getPermissionObject(framePermission, 'access').value

    //     if (value == '*') {
    //         framePermission.access = {}
    //     } else {
    //         framePermission.access = '*'
    //     }

    //     list[this.state.currentItemIndex].permissions[framePermissionIndex] = framePermission

    //     this.setState({ admins: list }, () => {
    //         this.permissionsToObject()
    //     })





    // }


    // changeTabsView = (frameId, key, value) => {
    //     let tabsView = this.state.tabsView
    //     setObject(tabsView, frameId + '.' + key, value)

    //     if (key == 'showAdvanced' && value && !getObject(tabsView, frameId + '.advancedTab')) {

    //         setObject(tabsView, frameId + '.advancedTab', 'view')

    //     }
    //     this.setState({ tabsView })
    // }



    // saveRoleAccess = () => {
    //     this.sidebarView.close()
    // }


    setAdmins = (admins, cb) => {
        this.setState({ admins }, () => {
            if (cb) {
                cb()
            }
        })
    }


    // setPermissionsObject = (permissionsObject, cb) => {

    //     this.setState({ permissionsObject }, () => {
    //         if (cb) {
    //             cb()
    //         }
    //     })

    // }



    render() {

        let variables = this.props.variables
        if (!variables) {
            variables = {}
        }
        // console.log('this.props.initData-01',this.props.initData)
        // console.log('this.props.initData-01', this.props.user.info?._id)
        // let user = this.props.initData?.users ?? '62c0253d0bf7bb42e2c87070'
        let user = this.props.initData?.hub ?? this.props.user?.info?._id
        variables.user = user
        variables.targetId = user
        // console.log(variables)

        return (
            <div className=' w-100 h-100 window-content-radius' style={{}}>



                {/* <div className='w-100 h-100 position-absolute overflow-hidden' >
                    <div style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -50, left: -50, background: 'radial-gradient(67.22% 50% at 50% 50%, rgba(88, 86, 214, 0.15) 0%, rgba(245, 228, 255, 0) 100%)' }}>

                    </div>

                    <div style={{ height: 1500, width: 1500, zIndex: 0, position: 'absolute', top: -100, left: "50%", background: 'radial-gradient(48.02% 35.72% at 50% 50%, rgba(124, 122, 255, 0.15) 0%, rgba(128, 255, 0, 0) 100%)' }}>

                    </div>
                </div> */}

                <div className=" w-100 h-100 scroll-no-scrollbar pb-5 position-relative  flex-column window-content-radius" style={{}}>
                    {/* <div className='w-100' style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                        <CAHeader ref={el => this.header = el} config={this.state.headerConfig} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} />
                    </div> */}

                    <div className=' w-100 '>
                        <div className='w-100' >

                            <PermissionsView maxWidth={650} frames={this.state.frames} width={this.props.width} admins={this.state.admins} setAdmins={this.setAdmins} applet={true} defaultOpen={true} variables={this.props.variables} />

                        </div>


                    </div>

                </div>




            </div>

        )
    }
}

// export default CAAccess;


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CAAccess);
